export const NAME_OVERRIDES: Record<string, string> = { TSM: 'Taiwan Semiconductor' };

export function firstWord(symbol: string, fullName: string | null | undefined): string {
  const o = NAME_OVERRIDES[symbol];
  if (o) return o.split(/\s+/)[0];
  if (!fullName) return symbol;
  return fullName.split(/\s+/)[0].replace(/[,.]$/, '');
}

export function colorFor(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return '#94a3b8';
  if (v >= 0.5) return '#4ade80';
  if (v > 0) return '#86efac';
  if (v >= -0.5) return '#94a3b8';
  return '#f87171';
}

export function secondsAgo(d: Date): number {
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 1000));
}

export function fmt(v: number | null | undefined): string {
  if (v == null || !Number.isFinite(v)) return '—';
  return `${v >= 0 ? '+' : ''}${v.toFixed(2)}`;
}
